export interface Enviroment {
  apiUrl: string;
  pixApiUrl: string;
  isMock: boolean;
  appVersion: string;
  appInsightsConString: string;
  supabaseAnonKey: string;
  adyenMerchantAccount?: string;
  adyenEnvironment?: "TEST" | "LIVE";
  adyenBackendUrl?: string;
  adyenDeviceId?: string;
}
const enviroment = {
  apiUrl: process.env.REACT_APP_API_URL,
  pixApiUrl: process.env.REACT_APP_PIX_API_URL,
  isMock: process.env.REACT_APP_IS_MOCK as unknown as boolean,
  appVersion: process.env.REACT_APP_VERSION,
  appInsightsConString: process.env.REACT_APP_CON_STRING,
  supabaseAnonKey: process.env.REACT_APP_SUPABASE_ANON_KEY ?? "",
  adyenMerchantAccount: process.env.REACT_APP_ADYEN_MERCHANT_ACCOUNT,
  adyenEnvironment: process.env.REACT_APP_ADYEN_ENVIRONMENT as "TEST" | "LIVE" | undefined,
  adyenBackendUrl: process.env.REACT_APP_ADYEN_BACKEND_URL,
  adyenDeviceId: process.env.REACT_APP_ADYEN_DEVICE_ID
} as Enviroment;
export default enviroment;

//https://create-react-app.dev/docs/adding-custom-environment-variables/
